import { render, staticRenderFns } from "./videoPoster.vue?vue&type=template&id=e3481e26&scoped=true&"
import script from "./videoPoster.vue?vue&type=script&lang=js&"
export * from "./videoPoster.vue?vue&type=script&lang=js&"
import style0 from "./videoPoster.vue?vue&type=style&index=0&id=e3481e26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3481e26",
  null
  
)

component.options.__file = "videoPoster.vue"
export default component.exports